import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    trainingModuleList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    
    trainingModuleDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    launchModule: {
        requesting: false,
        error: null,
        success: false,
        data: null
    }
  };

export const trainingModuleSlice = createSlice({
  name: 'trainingModule',
  initialState,
  reducers: {
    getTrainingModuleList: (state, action) => {
        state.trainingModuleList.requesting = true;
        state.trainingModuleList.error = null;
        state.trainingModuleList.items = [];
        state.trainingModuleList.success = false;
        state.trainingModuleList.filters = action.payload;
    },
    getTrainingModuleListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.trainingModuleList.requesting = false;        
        state.trainingModuleList.items = data;
        state.trainingModuleList.success = true; 
        state.trainingModuleList.pagination.current_page = current_page;
        state.trainingModuleList.pagination.per_page = per_page;
        state.trainingModuleList.pagination.total = total;
    },
    getTrainingModuleListFail: (state, action) => {        
        state.trainingModuleList.requesting = false;
        state.trainingModuleList.error = action.payload;
    },
    getTrainingModuleDetails: (state) => {
        state.trainingModuleDetails.requesting = true;
        state.trainingModuleDetails.error = null;
        state.trainingModuleDetails.data = null;
        state.trainingModuleDetails.success = false; 
    },
    getTrainingModuleDetailsSuccess: (state, action) => {
        state.trainingModuleDetails.requesting = false;
        state.trainingModuleDetails.data = action.payload;
        state.trainingModuleDetails.success = true; 
    },
    getTrainingModuleDetailsFail: (state, action) => {        
        state.trainingModuleDetails.requesting = false;
        state.trainingModuleDetails.error = action.payload;
    },
    doTrainingModuleCreate: (state) => {
        state.trainingModuleDetails.requesting = true;
        state.trainingModuleDetails.error = null;
        state.trainingModuleDetails.data = null;
        state.trainingModuleDetails.success = false; 
    },
    doTrainingModuleUpdate: (state) => {
        state.trainingModuleDetails.requesting = true;
        state.trainingModuleDetails.error = null;
        state.trainingModuleDetails.data = null;
        state.trainingModuleDetails.success = false; 
    },
    doTrainingModuleDelete: (state) => {
        state.trainingModuleDetails.requesting = true;
        state.trainingModuleDetails.error = null;
        state.trainingModuleDetails.data = null;
        state.trainingModuleDetails.success = false; 
    },

    doTrainingModuleReset: (state) => {		
      state.trainingModuleDetails.data = null;
    },

    getLaunchTrainingModule: (state) => {
        state.launchModule.requesting = true;
        state.launchModule.error = null;
        state.launchModule.data = null;
        state.launchModule.success = false; 
    },
    getLaunchTrainingModuleSuccess: (state, action) => {
        state.launchModule.requesting = false;
        console.log(action.payload);
        state.launchModule.data = action.payload;
        state.launchModule.success = true; 
    },
    getLaunchTrainingModuleFail: (state, action) => {        
        state.launchModule.requesting = false;
        state.launchModule.error = action.payload;
    },
  },
})

export const { 
    getTrainingModuleList, getTrainingModuleListSuccess, getTrainingModuleListFail,
    getTrainingModuleDetails, getTrainingModuleDetailsSuccess, getTrainingModuleDetailsFail,
    doTrainingModuleCreate, doTrainingModuleUpdate, doTrainingModuleDelete,
    doTrainingModuleReset,
    getLaunchTrainingModule, getLaunchTrainingModuleSuccess, getLaunchTrainingModuleFail,
} = trainingModuleSlice.actions

export default trainingModuleSlice.reducer